
import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import { Getter, Action } from "vuex-class";

import { Message } from "element-ui";

@Component
export default class Document extends Vue {
  get showSearch() {
    return (
      this.showCard &&
      !!this.searchKey &&
      this.globalSearchList.infos.data &&
      this.globalSearchList.infos.data.length > 0
    );
  }

  searchKey: string = "";
  showCard: boolean = false;
  categoryColor: any[] = ["#659FF6", "#13227a", "#53B8AC", "#DD7335"];
  config: any = require("./conf.json");

  @Getter globalSearchList: any;
  @Getter hotWords: any;

  @Action("getHotWords") getHotWords: Function;
  @Getter productDocs: any;
  @Action("getDocProducts") getDocProducts: Function;
  @Action("getGlobalSearchDoc") getGlobalSearchDoc: Function;

  mounted() {
    this.getDocProducts({ OnlyEnabled: true }).then(()=>{
      this.productDocs.infos.push({
        Name:'平台',
        children:[{
          Name: '天际Paas平台',
          ImageUrl: 'iconjianmo',
          LinkUrl:'https://lexiangla.com/teams/k100140/docs?order=weight,-edited_at&node=de4c1eeef9a511efa30a1208f825cf28&type=all&company_from=409301b0c06111e88af75254002b9121'
        }]
      })
    });
    this.getHotWords({ top: 10 });
  }

  // 是否有设计知识
  isShejiItem(item: any) {
    return item.DocVersions && item.DocVersions.length > 0;
  }
  // 是否有业务知识
  isYewuItem(item: any) {
    return (item.ProductDocCatalog && item.ProductDocCatalog.length > 0) || item.LinkUrl;
  }

  handleBox(param: any) {
    if (!!param.DocProductGUID) {
      this.$router.push({
        path: "/documents/docreview",
        query: {
          id: param.ProductDocCatalog,
          title: param.Name,
        },
      });
    } else if (!!param.LinkUrl) {
      window.open(param.LinkUrl, "_blank");
    }
  }

  handleMd(param: any) {
    if (!!param.DocProductGUID) {
      let route = this.$router.resolve({
        path: "/documents/mdreview",
        query: {
          productID: param.DocProductGUID,
        },
      });
      window.open(route.href, "_blank");
    } else if (!!param.LinkUrl) {
      window.open(param.LinkUrl, "_blank");
    }
  }

  handleSearch() {
    if (!!this.searchKey) {
      const params = {
        keyword: this.searchKey,
        pageIndex: 1,
        pageSize: 10,
      };
      this.getGlobalSearchDoc(params);
    }
  }

  handleCard(status: boolean) {
    setTimeout(() => {
      this.showCard = status;
    }, 200);
  }

  linkToSearch(key: any) {
    this.$router.push({
      path: "/home/globalSearch",
      query: {
        tabname: "文档",
        searchkey: key,
      },
    });
  }

  linkToReview(item: any) {
    this.$router.push({
      path: "/documents/docreview",
      query: {
        docid: item.Id,
        title: item.ProductName,
        ver: item.ProductVersion,
      },
    });
  }
  gotoPlatform() {
    window.location.href = "https://open.mingyuanyun.com/";
  }
}
